export type JsonPrimitive = string | number | boolean | null;
export type JsonValue = JsonPrimitive | JsonObject | JsonValue[];

// eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
export interface JsonObject {
  [key: string]: JsonValue;
}

const isBoolean = (value: unknown): value is boolean =>
  typeof value === 'boolean';

const isNumber = (value: unknown): value is number =>
  typeof value === 'number';

const isString = (value: unknown): value is string =>
  typeof value === 'string';

const isNull = (value: unknown): value is null =>
  value === null;

const isPlainObject = (value: unknown): value is JsonObject =>
  value !== null &&
  typeof value === 'object' &&
  !Array.isArray(value) &&
  Object.getPrototypeOf(value) === Object.prototype;

export const cleanExampleObjectForEditing = (
  obj: JsonObject,
  keysToKeep: Set<string>,
): JsonObject => {
  const result: JsonObject = {};

  for (const [key, value] of Object.entries(obj)) {
    if (keysToKeep.has(key)) {
      result[key] = value;
      continue;
    }

    if (isNull(value)) {
      result[key] = null;
      continue;
    }

    if (isBoolean(value)) {
      result[key] = false;
      continue;
    }

    if (isNumber(value)) {
      result[key] = null;
      continue;
    }

    if (isString(value)) {
      result[key] = '';
      continue;
    }

    if (Array.isArray(value)) {
      result[key] = value.map((jsonValue: JsonValue) => {
        if (isNull(jsonValue)) {
          return null;
        }
        if (isBoolean(jsonValue)) {
          return false;
        }
        if (isNumber(jsonValue)) {
          return null;
        }
        if (isString(jsonValue)) {
          return '';
        }
        if (isPlainObject(jsonValue)) {
          return cleanExampleObjectForEditing(jsonValue, keysToKeep);
        }

        return null;
      });
      continue;
    }

    if (isPlainObject(value)) {
      result[key] = cleanExampleObjectForEditing(value, keysToKeep);
      continue;
    }

    result[key] = null;
  }

  return result;
};
